export const isLocalDev = process.env.localDev || false;
